import { Button, Space, Table } from 'antd';
import { keyBy, merge, values } from 'lodash';
import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import { reactLocalStorage } from 'reactjs-localstorage';
import TableUtils from '../../../src/functions/TableUtils';
import PartnerApi, { STATUS } from '../../functions/api/partner/PartnerApi';
import MyUtil from '../../functions/MyUtil';
import ButtonFormatter from './ButtonFormatter';
import { columnTitlesPartners, TABLE } from './columns';
import ExportFilterButton from './ExportFilterButton';

class ListPartner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listPartners: [],
      redirectAdd: false,
      list: [],
      widthWindow: window.innerWidth,
      currentTotal: 0,
      currentDataSource: [],
    };
  }

  async componentDidMount() {
    const list = await PartnerApi.getAll();
    if (list)
      this.setState({
        listPartners: list,
        currentTotal: list.length,
        currentDataSource: list,
      });
    reactLocalStorage.setObject('partner.info', list);
  }

  activeFormatter = (cell, row) => {
    const { listPartners } = this.state;
    return (
      <ButtonFormatter
        cell={cell}
        row={row}
        onChangeList={this.handleChangeList}
        list={listPartners}
      />
    );
  };

  renderStatus = (cell, row) => {
    if (cell === STATUS.ACTIVE) {
      return 'ACTIVE';
    } else if (cell === STATUS.INACTIVE) {
      return 'INACTIVE';
    }

    return 'N/A';
  };

  handleInsertButtonClick = () => {
    this.setState({ redirectAdd: true });
  };

  handleChangeList = (list) => {
    this.setState({ listPartners: list });
  };

  tableSourceDidChange = (
    pagination,
    filters,
    sorter,
    { currentDataSource }
  ) => {
    this.setState({
      currentTotal: currentDataSource.length,
      currentDataSource: currentDataSource,
    });
  };

  getStatusFilter = () => {
    const filters = Object.entries(STATUS).map(([key, value]) => ({
      text: key,
      value,
    }));

    filters.push({
      text: '(trống)',
      value: null,
    });

    return {
      filters,
      onFilter: (value, record) => {
        return record?.status === value;
      },
    };
  };

  getColumnConfig = () => {
    const { listPartners } = this.state;

    const columnConfigs = [
      {
        dataIndex: 'part_id',
        key: 'part_id',
        fixed: 'left',
      },
      {
        dataIndex: 'part_name',
        key: 'part_name',
        fixed: 'left',
        ...TableUtils.getColumnSearchProps('part_name'),
      },
      {
        dataIndex: 'city_name',
        key: 'city_name',
        fixed: 'left',
        ...TableUtils.getColumnDropDownFilter(listPartners, 'city_name'),
      },
      {
        dataIndex: 'district_name',
        key: 'district_name',
      },
      {
        dataIndex: 'part_phon',
        key: 'part_phon',
        ...TableUtils.getColumnSearchProps('part_phon'),
      },
      {
        dataIndex: 'part_ctac_name',
        key: 'part_ctac_name',
      },
      {
        dataIndex: 'part_ctac_mobi',
        key: 'part_ctac_mobi',
        ...TableUtils.getColumnSearchProps('part_ctac_mobi'),
      },
      {
        dataIndex: 'part_addr',
        key: 'part_addr',
        ...TableUtils.getColumnSearchProps('part_addr'),
      },
      {
        dataIndex: 'status',
        key: 'status',
        render: this.renderStatus,
        ...this.getStatusFilter(),
      },
      {
        title: ' Chỉnh sửa',
        render: this.activeFormatter,
        fixed: 'right',
      },
    ];
    const titles = columnTitlesPartners.filter(
      (t) => t.hideOn !== TABLE.BACKEND
    );

    // merge titles with configs
    const mergeKey = 'dataIndex';
    return values(
      merge(keyBy(titles, mergeKey), keyBy(columnConfigs, mergeKey))
    );
  };

  render() {
    const {
      redirectAdd,
      currentTotal,
      currentDataSource,
      listPartners,
    } = this.state;

    const canAdd = MyUtil.hasPermission(this.props.match_parent.url, 'add');

    if (redirectAdd) {
      return (
        <Redirect push to={`${this.props.match_parent.url}/add-partner`} />
      );
    }

    const columns = this.getColumnConfig();

    return (
      <div className="content">
        <Space className="my-3">
          {canAdd && (
            <Button onClick={this.handleInsertButtonClick} type="primary">
              Thêm
            </Button>
          )}
          <ExportFilterButton currentDataSource={currentDataSource} />
        </Space>
        <Table
          rowKey="part_id"
          size="small"
          columns={columns}
          dataSource={listPartners}
          onChange={this.tableSourceDidChange}
          title={() => `Tổng số: ${currentTotal}`}
          scroll={{ x: 'max-content' }}
        />
      </div>
    );
  }
}

export default ListPartner;
